<form [formGroup]="dynamic_form_group">
  <ng-container *ngIf="display_type == 1">
    <mat-accordion class="example-headers-align" *ngFor="let section of sections" [id]="section.fieldID">
      <span class="d-none">
        {{ dynamic_form_group | DynamicFormSectionProcessingPipe : section :
        dynamic_form_group.get(section.fieldID):all_form.value}}
      </span>
      <ng-container
        *ngIf="!(section && section.validators && section.validators.hide && section.validators.hide.value)">
        <mat-expansion-panel #panel [expanded]="section.openAccrodion" DestoryDirective
          [afterViewInit]="addPanelRefToSectionRef" [param1]="section" [param2]="panel"
          (expandedChange)="section['enableQuestion'] ? accordionPanelClosed(section['enableQuestion']['fieldID'],panel,(section.multiple?dynamic_form_group: dynamic_form_group.get(section.fieldID)),section,parent_form) :''">
          <!--[disabled]="disabled"-->
          <mat-expansion-panel-header [collapsedHeight]="'auto'" [expandedHeight]="'auto'">
            <mat-panel-title class="m-auto"> {{section['enableQuestion']?
              section['enableQuestion']['label']:section.label}}
            </mat-panel-title>
            <mat-panel-description class="m-auto">
              <form [formGroup]="(section.multiple?dynamic_form_group: dynamic_form_group.get(section.fieldID))">
                <mat-radio-group aria-labelledby="example-radio-group-label" class="example-radio-group"
                  [id]="section.fieldID + section['enableQuestion'].fieldID"
                  [formControlName]="section['enableQuestion']['fieldID']" *ngIf="section['enableQuestion']">
                  <mat-radio-button class="example-radio-button"
                    *ngFor="let item of masters[section['enableQuestion']['masterPropName']]|| []" [value]="item.id">
                    {{item.title}}
                  </mat-radio-button>
                </mat-radio-group>
              </form>
            </mat-panel-description>
            <ng-container *ngIf="!(section.skipVerification) &&verificationRequired">
              <ng-template
                *ngTemplateOutlet="verification_status; context: {field:section,section:section,form_group:dynamic_form_group,form_control:dynamic_form_group.get(section.fieldID),verificationObj:verificationObj,is_section:1,verification_status_list:verification_status_list}">
              </ng-template>
            </ng-container>
          </mat-expansion-panel-header>

          <ng-template
            *ngTemplateOutlet="plotSection; context: {section:section,dynamic_form_group:dynamic_form_group,masters:masters}">
          </ng-template>
        </mat-expansion-panel>
      </ng-container>
    </mat-accordion>
  </ng-container>

  <ng-container *ngIf="display_type == 2">

    <ng-container *ngFor="let section of sections">
      <!-- {{section && (section.validators | json)}} -->

      <span class="d-none">
        {{ dynamic_form_group | DynamicFormSectionProcessingPipe : section :
        dynamic_form_group.get(section.fieldID):all_form.value}}
      </span>
      <ng-container
        *ngIf="!(section && section.validators && section.validators.hide && section.validators.hide.value)">
        <h6 class="dynamic_section_title mb-3" *ngIf="!section.disable_title">
          <span class="label-1">
            {{section.label}}
          </span>
          <ng-container *ngIf="!(section.skipVerification) &&verificationRequired">
            <ng-template
              *ngTemplateOutlet="verification_status; context: {field:section,section:section,form_group:dynamic_form_group,form_control:dynamic_form_group.get(section.fieldID),verificationObj:verificationObj,is_section:1,verification_status_list:verification_status_list}">
            </ng-template>
          </ng-container>
        </h6>

        <ng-template
          *ngTemplateOutlet="plotSection; context: {section:section,dynamic_form_group:dynamic_form_group,masters:masters}">
        </ng-template>
        <ng-container>
          <ng-template
            *ngTemplateOutlet="button; context: {section:section,form_group:dynamic_form_group.get(section.fieldID),parent_form:dynamic_form_group,stepper:null}">
          </ng-template>
        </ng-container>
      </ng-container>
    </ng-container>
  </ng-container>

  <ng-container *ngIf="display_type == 5">
    <div class="dynamic-tab">
      <div class="tabs">
        <div class="tab" *ngFor="let section of sections;let ind = index">
          <span class="d-none">
            {{ dynamic_form_group | DynamicFormSectionProcessingPipe : section :
            dynamic_form_group.get(section.fieldID) :all_form.value}}
          </span>
          <ng-container
            *ngIf="!(section && section.validators && section.validators.hide && section.validators.hide.value)"> <input
              type="checkbox" [id]="'chck' +ind" class="d-none tabId" [checked]='ind==0'>
            <label class="tab-label" [attr.for]="'chck' +ind">{{section.label}}

              <ng-container *ngIf="!(section.skipVerification) &&verificationRequired">
                <ng-template
                  *ngTemplateOutlet="verification_status; context: {field:section,section:section,form_group:dynamic_form_group,form_control:dynamic_form_group.get(section.fieldID),verificationObj:verificationObj,is_section:1,verification_status_list:verification_status_list}">
                </ng-template>
              </ng-container>
            </label>
            <div class="tab-content padding-sm-0">
              <ng-template
                *ngTemplateOutlet="plotSection; context: {section:section,dynamic_form_group:dynamic_form_group,masters:masters}">
              </ng-template>

              <ng-container>
                <ng-template
                  *ngTemplateOutlet="button; context: {section:section,form_group:dynamic_form_group.get(section.fieldID),parent_form:dynamic_form_group,stepper:'inp',ind:ind}">
                </ng-template>
              </ng-container>
            </div>
          </ng-container>
        </div>

      </div>
    </div>
  </ng-container>
  <ng-container *ngIf="false && display_type == 5">
    <div class="dynamic-tab">
      <mat-stepper #stepper [orientation]="stepperOrientation">
        <mat-step *ngFor="let section of sections;let ind = index">
          <span class="d-none">
            {{ dynamic_form_group | DynamicFormSectionProcessingPipe : section :
            dynamic_form_group.get(section.fieldID):all_form.value}}
          </span>
          <ng-template matStepLabel>
            {{section.label}}

            <ng-container *ngIf="!(section.skipVerification) &&verificationRequired">
              <ng-template
                *ngTemplateOutlet="verification_status; context: {field:section,section:section,form_group:dynamic_form_group,form_control:dynamic_form_group.get(section.fieldID),verificationObj:verificationObj,is_section:1,verification_status_list:verification_status_list}">
              </ng-template>
            </ng-container>
          </ng-template>
          <!-- <ng-template matStepContent> -->

          <!-- <h6 class="dynamic_section_title mb-3">
              <span class="label-1">
                {{section.label}}
              </span>
              <ng-container *ngIf="!(section.skipVerification) &&verificationRequired">
                <ng-template
                  *ngTemplateOutlet="verification_status; context: {field:section,section:section,form_group:dynamic_form_group,form_control:dynamic_form_group.get(section.fieldID),verificationObj:verificationObj,is_section:1,verification_status_list:verification_status_list}">
                </ng-template>
              </ng-container>
            </h6> -->

          <ng-template
            *ngTemplateOutlet="plotSection; context: {section:section,dynamic_form_group:dynamic_form_group,masters:masters}">
          </ng-template>
          <!-- <div class="row">
              <ng-container *ngFor="let item of (section.sectionFields||[]);">
                <div [class]="'col-md-' + (item.width || 4)+' ' + item.controlClass"
                  *ngIf="!(item && item.UIValidationObjStruct && item.UIValidationObjStruct.hide && item.UIValidationObjStruct.hide.value)">
                  <ng-template
                    *ngTemplateOutlet="edit_mode; context: {item:item,hide_label:0,width:item.width || 6,section : section,form_group:section.multiple?section.multiple_form: dynamic_form_group.get(section.fieldID)}">
                  </ng-template>
                </div>
              </ng-container>
            </div>

            <ng-container *ngIf="section && section.sections">
              <tm-dynamic-form-v3 [main_form]="dynamic_form_group" [parent_form]="dynamic_form_group"
                [dynamic_form_group]="dynamic_form_group.get(section.fieldID)"
                [display_type]="section.sub_section_display_type" [sections]="section.sections" [masters]="masters">
              </tm-dynamic-form-v3>
            </ng-container> -->

          <ng-container>
            <ng-template
              *ngTemplateOutlet="button; context: {section:section,form_group:dynamic_form_group.get(section.fieldID),parent_form:dynamic_form_group,stepper:stepper,ind:ind}">
            </ng-template>
          </ng-container>
          <!-- </ng-template> -->


        </mat-step>

      </mat-stepper>
    </div>
  </ng-container>

</form>

<ng-template #edit_mode let-item="item" let-hide_label="hide_label" let-width="width" let-section="section"
  let-form_group="form_group">
  <form [formGroup]="form_group" [id]="section.fieldID + item.fieldID" >
    <ng-container *ngIf="item.dataTypeId == -1">
      <app-tm-address [masters]="masters" [form_control]="form_group.get(item.fieldID)" [readonly]="false"
        [label]="item.label" [field]="item" [dynamic_form_group]="form_group">
      </app-tm-address>
    </ng-container>
    <ng-container *ngIf="item.dataTypeId == 1">
      <!-- TEXT -->
      <mat-form-field floatLabel='always'>
        <mat-label>
          <ng-container *ngIf="!hide_label">
            <span [title]="item.label | translate">
              {{item.label | translate}}
            </span>
          </ng-container>
        </mat-label>
        <input matInput [formControlName]="item.fieldID"
          (keyup)="item.transform ? transformFn(form_group.get(item.fieldID),item.transform):null"
          [placeholder]="item.placeholder"
          [maxlength]="item.UIValidationObjStruct && item.UIValidationObjStruct.max_length  && item.UIValidationObjStruct.max_length.value ?  item.UIValidationObjStruct.max_length.value: 999999999"
          [minlength]="item.UIValidationObjStruct && item.UIValidationObjStruct.min_length  && item.UIValidationObjStruct.min_length.value ?  item.UIValidationObjStruct.min_length.value: 0"
          [readonly]="(item && item.UIValidationObjStruct&& item.UIValidationObjStruct.disabled &&item.UIValidationObjStruct.disabled.value == 1 || verificationObj[item.fieldID] == 3) ? true : false">
        <mat-error *ngIf="form_group && form_group.get(item.fieldID).hasError('required');else maxlength">
          Field is mandatory
        </mat-error>
        <ng-template #maxlength>
          <mat-error *ngIf="form_group && form_group.get(item.fieldID).hasError('maxlength');else minlength">
            Maximum length ({{item.UIValidationObjStruct.max_length.value || 999999999}}) has exceeded
          </mat-error>
        </ng-template>
        <ng-template #minlength>
          <mat-error *ngIf="form_group && form_group.get(item.fieldID).hasError('minlength'); else maxvalue">
            Minimum length must be ({{item.UIValidationObjStruct.min_length.value || 0}})
          </mat-error>
        </ng-template>
        <ng-template #maxvalue>
          <mat-error *ngIf="form_group && form_group.get(item.fieldID).hasError('max');else minvalue">
            Value must be lesser than ({{item.UIValidationObjStruct.max_value.value || 0}})
          </mat-error>
        </ng-template>
        <ng-template #minvalue>
          <mat-error *ngIf="form_group && form_group.get(item.fieldID).hasError('min'); else pattern">
            Value must be greater than ({{item.UIValidationObjStruct.min_value.value || 999999}})
          </mat-error>
        </ng-template>
        <ng-template #pattern>
          <mat-error *ngIf="form_group && form_group.get(item.fieldID).hasError('pattern')">
            {{'Invalid input'}}
          </mat-error>
        </ng-template>
      </mat-form-field>
    </ng-container>
    <ng-container *ngIf="item.dataTypeId == 2">
      <!-- NUMBER -->
      <mat-form-field floatLabel="always">
        <mat-label>
          <ng-container *ngIf="!hide_label">
            <span [title]="item.label | translate">
              {{item.label | translate}}
            </span>
          </ng-container>

        </mat-label>
        <input matInput type="number" [formControlName]="item.fieldID" [placeholder]="item.placeholder"
          [readonly]="(item && item.UIValidationObjStruct&& item.UIValidationObjStruct.disabled  && item.UIValidationObjStruct.disabled.value == 1 || verificationObj[item.fieldID] == 3) ? true : false"
          [maxlength]="item.UIValidationObjStruct && item.UIValidationObjStruct.max_length && item.UIValidationObjStruct.max_length.value ? item.UIValidationObjStruct.max_length.value: 999999999"
          [minlength]="item.UIValidationObjStruct && item.UIValidationObjStruct.min_length &&item.UIValidationObjStruct.min_length.value ? item.UIValidationObjStruct.min_length.value: 0">
        <mat-error *ngIf="form_group && form_group.get(item.fieldID).hasError('required');else maxlengthnum">
          Field is mandatory
          <!-- <span [innerHTML]="label + ' is mandatory'"></span> -->
        </mat-error>
        <ng-template #maxlengthnum>
          <mat-error *ngIf="form_group && form_group.get(item.fieldID).hasError('maxlength');else minlengthnum">
            Maximum length ({{item.UIValidationObjStruct.max_length.value || 999999999}}) has exceeded
          </mat-error>
        </ng-template>
        <ng-template #minlengthnum>
          <mat-error *ngIf="form_group && form_group.get(item.fieldID).hasError('minlength'); else maxvaluenum">
            Minimum length must be ({{item.UIValidationObjStruct.min_length.value || 0}})
          </mat-error>
        </ng-template>
        <ng-template #maxvaluenum>
          <mat-error *ngIf="form_group && form_group.get(item.fieldID).hasError('max');else minvaluenum">
            Value must be lesser than ({{item.UIValidationObjStruct.max_value.value || 0}})
          </mat-error>
        </ng-template>
        <ng-template #minvaluenum>
          <mat-error *ngIf="form_group && form_group.get(item.fieldID).hasError('min'); else patternnum">
            Value must be greater than ({{item.UIValidationObjStruct.min_value.value || 0}})
          </mat-error>
        </ng-template>
        <ng-template #patternnum>
          <mat-error *ngIf="form_group && form_group.get(item.fieldID).hasError('pattern')">
            {{'Invalid input'}}
          </mat-error>
        </ng-template>
      </mat-form-field>
    </ng-container>
    <ng-container *ngIf="item.dataTypeId == 3">
      <!-- DATE -->
      <tm-date-picker [form]="form_group" [controlName]="item.fieldID"
        [required]="item.UIValidationObjStruct && item.UIValidationObjStruct.mandatory  && item.UIValidationObjStruct.mandatory.value ?  true: false"
        [minValue]="item.UIValidationObjStruct && item.UIValidationObjStruct.min_value  && item.UIValidationObjStruct.min_value.value ? item.UIValidationObjStruct.min_value.value : null "
        [maxValue]="item.UIValidationObjStruct && item.UIValidationObjStruct.max_value  && item.UIValidationObjStruct.max_value.value ? item.UIValidationObjStruct.max_value.value : null "
        [label]="item.label" [value]="form_group.value &&form_group.value[item.fieldID]"
        [placeholder]="item.placeholder" (onChange)="optionSelected($event,item.expression,form_group,item)"
        [disabled]="(item && item.UIValidationObjStruct&& item.UIValidationObjStruct.disabled  && item.UIValidationObjStruct.disabled.value == 1 || verificationObj[item.fieldID] == 3) ? true : false">
      </tm-date-picker>
    </ng-container>
    <ng-container *ngIf="item.dataTypeId == 4">
      <!-- DATE & TIME -->
      <tm-date-time-picker-t2 [form]="form_group" [controlName]="item.fieldID"
        [required]="item.UIValidationObjStruct && item.UIValidationObjStruct.mandatory  && item.UIValidationObjStruct.mandatory.value ? true: false"
        [label]="item.label" [value]="form_group.value &&form_group.value[item.fieldID]"
        [placeholder]="item.placeholder"></tm-date-time-picker-t2>
    </ng-container>
    <ng-container *ngIf="item.dataTypeId == 5">
      <!-- SINGLE FILE -->
      <ng-container *ngIf="form_group.value && form_group.value[item.fieldID];else defaultCRP">
        <tm-files-v2 [form_group]="form_group"
          [required]="item.UIValidationObjStruct && item.UIValidationObjStruct.mandatory  && item.UIValidationObjStruct.mandatory.value ? true: false"
          [form_control]="item.fieldID" [label]="item.label" [style]="{'margin-bottom':'0px'}" [multiple]="0"
          [supported_files]="item.documentValidation && item.documentValidation.accepetedTypes ? item.documentValidation.accepetedTypes : ['pdf', 'doc', 'docx', 'jpeg', 'png', 'jpg', 'xlsx', 'xlsm', 'jfif', 'mp3', 'ogv', 'wav' , 'amr' , 'ogg' , 'xls' , 'svg' ]"
          [disabled]="(item && item.UIValidationObjStruct&& item.UIValidationObjStruct.disabled  && item.UIValidationObjStruct.disabled.value == 1 || verificationObj[item.fieldID] == 3) ? true : false">
          [file_size_validation]="item.file_size_validation"
          [data]="form_group.value && form_group.value[item.fieldID] ? form_group.value[item.fieldID] : null"
          [result]="form_group.value && form_group.value[item.fieldID] ? form_group.value[item.fieldID] : null">
        </tm-files-v2>
      </ng-container>
      <ng-template #defaultCRP>
        <tm-files-v2 [form_group]="form_group"
          [required]="item.UIValidationObjStruct && item.UIValidationObjStruct.mandatory  && item.UIValidationObjStruct.mandatory.value ? true: false"
          [form_control]="item.fieldID" [label]="item.label" [style]="{'margin-bottom':'0px'}" [multiple]="0"
          [file_size_validation]="item.file_size_validation"
          [supported_files]="item.documentValidation && item.documentValidation.accepetedTypes ? item.documentValidation.accepetedTypes : ['pdf', 'doc', 'docx', 'jpeg', 'png', 'jpg', 'xlsx', 'xlsm', 'jfif', 'mp3', 'ogv', 'wav' , 'amr' , 'ogg' , 'xls' , 'svg' ]"
          [disabled]="(item && item.UIValidationObjStruct&& item.UIValidationObjStruct.disabled  && item.UIValidationObjStruct.disabled.value == 1 || verificationObj[item.fieldID] == 3) ? true : false">
          [data]="form_group.value && form_group.value[item.fieldID] ? form_group.value[item.fieldID] : null"
          [result]="form_group.value && form_group.value[item.fieldID] ? form_group.value[item.fieldID] : null">
        </tm-files-v2>
      </ng-template>


    </ng-container>
    <ng-container *ngIf="item.dataTypeId == 6">
      <!-- MULTIPE FILES -->
      <ng-container *ngIf="form_group.value && form_group.value[item.fieldID];else defaultCRPDE">
        <tm-files-v2 [form_group]="form_group"
          [required]="item.UIValidationObjStruct && item.UIValidationObjStruct.mandatory  && item.UIValidationObjStruct.mandatory.value ? true: false"
          [style]="{'margin-bottom':'0px'}" [form_control]="item.fieldID" [label]="item.label" [multiple]="1"
          [supported_files]="item.documentValidation && item.documentValidation.accepetedTypes ? item.documentValidation.accepetedTypes : ['pdf', 'doc', 'docx', 'jpeg', 'png', 'jpg', 'xlsx', 'xlsm', 'jfif', 'mp3', 'ogv', 'wav' , 'amr' , 'ogg' , 'xls' , 'svg' ]"
          [file_size_validation]="item.file_size_validation"
          [disabled]="(item && item.UIValidationObjStruct&& item.UIValidationObjStruct.disabled  && item.UIValidationObjStruct.disabled.value == 1 || verificationObj[item.fieldID] == 3) ? true : false">
          [data]="form_group.value && form_group.value[item.fieldID] ? form_group.value[item.fieldID] : null"
          [result]="form_group.value && form_group.value[item.fieldID] ? form_group.value[item.fieldID] : null">
        </tm-files-v2>

      </ng-container>
      <ng-template #defaultCRPDE>
        <tm-files-v2 [form_group]="form_group"
          [required]="item.UIValidationObjStruct && item.UIValidationObjStruct.mandatory  && item.UIValidationObjStruct.mandatory.value ? true: false"
          [style]="{'margin-bottom':'0px'}" [form_control]="item.fieldID" [label]="item.label" [multiple]="1"
          [supported_files]="item.documentValidation && item.documentValidation.accepetedTypes ? item.documentValidation.accepetedTypes : ['pdf', 'doc', 'docx', 'jpeg', 'png', 'jpg', 'xlsx', 'xlsm', 'jfif', 'mp3', 'ogv', 'wav' , 'amr' , 'ogg' , 'xls' , 'svg' ]"
          [disabled]="(item && item.UIValidationObjStruct&& item.UIValidationObjStruct.disabled  && item.UIValidationObjStruct.disabled.value == 1 || verificationObj[item.fieldID] == 3) ? true : false">
          [data]="form_group.value && form_group.value[item.fieldID] ? form_group.value[item.fieldID] : null"
          [result]="form_group.value && form_group.value[item.fieldID] ? form_group.value[item.fieldID] : null">
        </tm-files-v2>

      </ng-template>

    </ng-container>
    <ng-container *ngIf="item.dataTypeId == 7">
      <app-phone-number [hide_label]="item.hide_label" [placeholder]="item.placeholder"
        [options]="item.suggestedValues ||item.list" [options_data]="item.option_form_control && item.option_form_control !=''?form_group.value
                 &&form_group.value[item.option_form_control] :null " [maxLength]="item.maxLength"
        [option_form_control]="item.option_form_control" [form]="form_group" [controlName]="item.fieldID"
        [label]="item.label" [data]="form_group.value
                &&form_group.value[item.fieldID]" [pattern_desc]="'^[0-9]*$'" [required]="1">
      </app-phone-number>
    </ng-container>
    <ng-container *ngIf="item.dataTypeId == 8">
      <!-- {{form_group.value | json}} -->
      <tm-select
        [options]="item.isDataMaster ? dynamic_form_group.value[item.isDataMaster.options_key]  : item.suggestedValues ||masters[item.masterPropName] ||[]"
        [id_property]="item.id_property || 'id'" [title_property]="item.title_property || 'title'"
        [data]="form_group.value[item.fieldID]" [form_group]="form_group" [donot_autoselect]="1"
        [mandatory]="item.UIValidationObjStruct && item.UIValidationObjStruct.mandatory  && item.UIValidationObjStruct.mandatory.value ? 1 : 0"
        [form_control]="item.fieldID" [label]="item.label" [hide_label]="item.hide_label"
        [label_overflow]="item.label_overflow" (selected_obj)="optionSelected($event,item.expression,form_group,item)"
        [enable_virtual_scroll]="item.enable_virtual_scroll"
        [no_data_found_message]="item.no_data_found_message || 'Type here to search'"
        (fetchEntries)="fetchMasterEntries($event,item.api_route,masters,item,section)"
        [readonly]="(item && item.UIValidationObjStruct&& item.UIValidationObjStruct.disabled  && item.UIValidationObjStruct.disabled.value == 1 || verificationObj[item.fieldID] == 3) ? true : false">
      </tm-select>
    </ng-container>
    <ng-container *ngIf="item.dataTypeId == 9">
      <tm-multi-select
        [options]="item.isDataMaster ? dynamic_form_group.value[item.isDataMaster.options_key]  : item.suggestedValues ||masters[item.masterPropName] ||[]"
        [id_property]="item.id_property || 'id'" [title_property]="item.title_property || 'title'"
        [data]="form_group.value &&form_group.value[item.fieldID]" [form_group]="form_group"
        [mandatory]="item.UIValidationObjStruct && item.UIValidationObjStruct.mandatory  && item.UIValidationObjStruct.mandatory.value ? 1 : 0"
        [form_control]="item.fieldID" [hide_label]="item.hide_label" [label_overflow]="item.label_overflow"
        [label]="item.label" (selected_obj)="optionSelected($event,item.expression,form_group,item)"
        [enable_virtual_scroll]="item.enable_virtual_scroll"
        [no_data_found_message]="item.no_data_found_message || 'Type here to search'"
        (fetchEntries)="fetchMasterEntries($event,item.api_route,masters,item,section)"
        [disabled]="(item && item.UIValidationObjStruct&& item.UIValidationObjStruct.disabled  && item.UIValidationObjStruct.disabled.value == 1 || verificationObj[item.fieldID] == 3) ? true : false">
      </tm-multi-select>
    </ng-container>
    <ng-container *ngIf="item.dataTypeId == 11 && item.fieldID && item.numberControl">
      <app-dynamic-phone-number [isd_formControl]="item.fieldID" [form]="form_group" [masters]="masters"
        [isd_label]="item.label" [isd_placeholder]="item.placeholder" [disabled]="item.disabled"
        [mandatory]="item.UIValidationObjStruct && item.UIValidationObjStruct.mandatory  && item.UIValidationObjStruct.mandatory.value ? 1 : 0"
        [mobile_number_placeholder]="item.numberControlplaceholder" [mobile_number_form_control]="item.numberControl"
        [disabled]="(item && item.UIValidationObjStruct&& item.UIValidationObjStruct.disabled  && item.UIValidationObjStruct.disabled.value == 1 || verificationObj[item.fieldID] == 3) ? true : false">
      </app-dynamic-phone-number>
    </ng-container>
    <ng-container *ngIf="item.dataTypeId == 12">
      <app-radio [form]="form_group" [controlName]="item.fieldID" [label]="item.label"
        [required]="item.UIValidationObjStruct && item.UIValidationObjStruct.mandatory  && item.UIValidationObjStruct.mandatory.value ? 1 : 0"
        [options]="item.suggestedValues ||masters[item.masterPropName]"
        [disabled]="(item && item.UIValidationObjStruct&& item.UIValidationObjStruct.disabled  && item.UIValidationObjStruct.disabled.value == 1 || verificationObj[item.fieldID] == 3) ? true : false">
      </app-radio>
    </ng-container>
    <ng-container *ngIf="item.dataTypeId == 13">
      <tm-checkbox [label]="item.label" [form_group]="form_group" [form_control]="item.fieldID"
        [disabled]="(item && item.UIValidationObjStruct&& item.UIValidationObjStruct.disabled  && item.UIValidationObjStruct.disabled.value == 1 || verificationObj[item.fieldID] == 3) ? true : false">
      </tm-checkbox>
      <!-- [data]="form_group.value[item.fieldID]" -->
    </ng-container>
    <ng-container *ngIf="item.dataTypeId == 14">
      <tm-digital-signature [form_group]="form_group" [height]="item.height || 150" [form_control]="item.fieldID"
        [field]="item"
        [disabled]="(item && item.UIValidationObjStruct&& item.UIValidationObjStruct.disabled  && item.UIValidationObjStruct.disabled.value == 1 || verificationObj[item.fieldID] == 3) ? true : false">

      </tm-digital-signature>
    </ng-container>
    <ng-container *ngIf="item.dataTypeId == 15">
      <tm-profile-picture [form_group]="form_group" [field]="item"
        [disabled]="(item && item.UIValidationObjStruct&& item.UIValidationObjStruct.disabled  && item.UIValidationObjStruct.disabled.value == 1 || verificationObj[item.fieldID] == 3) ? true : false">
      </tm-profile-picture>
    </ng-container>
    <ng-container *ngIf="item.dataTypeId == 16">
      <tm-dynamic-documents [form_group]="form_group" [masters]="masters" [field]="item" [section]="section"
        [verificationRequired]="verificationRequired" [callbackFn]="callbackFn" [alertId]="alertId"
        [verification_status_list]="verification_status_list"
        [disabled]="(item && item.UIValidationObjStruct&& item.UIValidationObjStruct.disabled  && item.UIValidationObjStruct.disabled.value == 1 || verificationObj[item.fieldID] == 3) ? true : false">
      </tm-dynamic-documents>
    </ng-container>
    <ng-container *ngIf="item.dataTypeId == 17">
      <tm-dynamic-checklist [form_group]="form_group" [masters]="masters" [field]="item" [section]="section"
        [disabled]="(item && item.UIValidationObjStruct&& item.UIValidationObjStruct.disabled  && item.UIValidationObjStruct.disabled.value == 1 || verificationObj[item.fieldID] == 3) ? true : false">

      </tm-dynamic-checklist>
    </ng-container>
    <ng-container *ngIf="item.dataTypeId == 18">
      <label class="form-check-label" for="exampleCheck1" *ngIf="item.paragraphLabel">
        <span [innerHTML]="item.paragraphLabel"></span>
      </label>
      <app-checkbox [form_group]="form_group" [controlName]="item.fieldID" [field]="item" [label]="item.label"
        [disabled]="(item && item.UIValidationObjStruct&& item.UIValidationObjStruct.disabled  && item.UIValidationObjStruct.disabled.value == 1 || verificationObj[item.fieldID] == 3) ? true : false"
        [mandatory]="item.UIValidationObjStruct && item.UIValidationObjStruct.mandatory  && item.UIValidationObjStruct.mandatory.value ?true:false">
      </app-checkbox>
    </ng-container>
    <ng-container *ngIf="item.dataTypeId == 19">
      <tm-month-year [form]="form_group" [controlName]="item.fieldID" [float_label]="'always'"
        [disabled]="(item && item.UIValidationObjStruct&& item.UIValidationObjStruct.disabled  && item.UIValidationObjStruct.disabled.value == 1 || verificationObj[item.fieldID] == 3) ? true : false"
        [value]="form_group.value[item.fieldID]" [label]="item.label|translate" [placeholder]="item.placeholder"
        (onChange)="optionSelected($event,item.expression,form_group,item)"
        [required]="item.UIValidationObjStruct &&  item.UIValidationObjStruct.mandatory ? item.UIValidationObjStruct.mandatory.value : 0"
        [disabled]="item.UIValidationObjStruct &&  item.UIValidationObjStruct.disabled ? item.UIValidationObjStruct.disabled.value : 0">
      </tm-month-year>
    </ng-container>
    <ng-container *ngIf="item.dataTypeId == 20">
      <tm-dynamic-assessment [form_group]="form_group" [masters]="masters" [field]="item" [section]="section"
        [disabled]="(item && item.UIValidationObjStruct&& item.UIValidationObjStruct.disabled  && item.UIValidationObjStruct.disabled.value == 1 || verificationObj[item.fieldID] == 3) ? true : false">

      </tm-dynamic-assessment>
    </ng-container>
    <ng-container *ngIf="item.dataTypeId == 21">
      <app-html-text-editor [form]="form_group" [controlName]='item.fieldID' [label]="item['label'] |translate"
        [disabled]="(item && item.UIValidationObjStruct&& item.UIValidationObjStruct.disabled  && item.UIValidationObjStruct.disabled.value == 1 || verificationObj[item.fieldID] == 3) ? true : false"
        [required]="item.UIValidationObjStruct && item.UIValidationObjStruct.mandatory  && item.UIValidationObjStruct.mandatory.value ?true:false">
      </app-html-text-editor>
    </ng-container>
    <ng-container *ngIf="item.dataTypeId == 22">
      <mat-star-rating [form_group]="form_group" [form_control]="item.fieldID"
        [rating]="form_group.value[item.fieldID] ||1"
        [disabled]="(item && item.UIValidationObjStruct&& item.UIValidationObjStruct.disabled  && item.UIValidationObjStruct.disabled.value == 1 || verificationObj[item.fieldID] == 3) ? true : false">
      </mat-star-rating>
    </ng-container>
    <ng-container *ngIf="item.dataTypeId == 23">
      <tm-declaration-documents [form_group]="form_group" [masters]="masters" [field]="item" [section]="section"
        [alertId]="alertId" [type]="type" [verificationRequired]="verificationRequired" [callbackFn]="callbackFn"
        [verification_status_list]="verification_status_list" [disableDownload]="item.disableDownload"
        [disabled]="(item && item.UIValidationObjStruct&& item.UIValidationObjStruct.disabled  && item.UIValidationObjStruct.disabled.value == 1 || verificationObj[item.fieldID] == 3) ? true : false">
      </tm-declaration-documents>
    </ng-container>
    <ng-container *ngIf="item.dataTypeId == 24">
      <app-confirm-password [form]="form_group" [controlName]="item.fieldID" [float_label]="'always'" [field_obj]="item"
        [value]="form_group.value[item.fieldID]" [label]="item.label|translate" [placeholder]="item.placeholder"
        (onChange)="optionSelected($event,item.expression,form_group,item)" [type]="item.type"
        [maxlength]="item.UIValidationObjStruct && item.UIValidationObjStruct.max_length  && item.UIValidationObjStruct.max_length.value ?  item.UIValidationObjStruct.max_length.value: 999999999"
        [minlength]="item.UIValidationObjStruct && item.UIValidationObjStruct.min_length  && item.UIValidationObjStruct.min_length.value ?  item.UIValidationObjStruct.min_length.value: 0"
        [required]="item.UIValidationObjStruct && item.UIValidationObjStruct.mandatory ? item.UIValidationObjStruct.mandatory.value : 0"
        [disabled]="item.UIValidationObjStruct && item.UIValidationObjStruct.disabled ?item.UIValidationObjStruct.disabled.value : 0">
      </app-confirm-password>
    </ng-container>
  </form>
</ng-template>


<ng-template #button let-form_group="form_group" let-section="section" let-stepper="stepper" let-ind="ind">
  <div class="row mt-3" *ngIf="!disable_button">
    <div class="col-md-12 form-group">

      <!-- <button style="min-width: 100px;" class="ml-auto hide-mbl btn-sm blob-btn-cancel btn mx-1 mx-1 tallite-action"
        (click)="previous(stepper,ind,sections)" *ngIf="ind != 0">
        {{ 'BTN.previous' | translate}}
        <span class="blob-btn-cancel__inner">
          <span class="blob-btn-cancel__blobs">
            <span class="blob-btn-cancel__blob"></span>
            <span class="blob-btn-cancel__blob"></span>
            <span class="blob-btn-cancel__blob"></span>
            <span class="blob-btn-cancel__blob"></span>
          </span>
        </span>
      </button>

      <button style="min-width: 100px;" class="blob-btn  btn-sm  btn   mx-1 tallite-action my-auto"
        (click)="saveCallbackfn(ind)"
        type="submit">
        {{ ('Next' | translate) }}
        <span class="blob-btn__inner">
          <span class="blob-btn__blobs">
            <span class="blob-btn__blob"></span>
            <span class="blob-btn__blob"></span>
            <span class="blob-btn__blob"></span>
            <span class="blob-btn__blob"></span>
          </span>
        </span>
      </button> -->

      <button style="min-width: 100px;" class="blob-btn btn-sm  btn   mx-1 tallite-action my-auto float-right"
        (click)="saveDetails(section,stepper,form_group,dynamic_form_group,sections,!(ind == sections.length -1 ),masters,ind,'chck' +ind)"
        type="submit">
        {{ ind == sections.length -1 ?
        ('BTN.save' | translate) :
        ('BTN.saveAndProceed' | translate) }}
        <span class="blob-btn__inner">
          <span class="blob-btn__blobs">
            <span class="blob-btn__blob"></span>
            <span class="blob-btn__blob"></span>
            <span class="blob-btn__blob"></span>
            <span class="blob-btn__blob"></span>
          </span>
        </span>
      </button>
    </div>
  </div>

</ng-template>

<ng-template #verification_status let-field="field" let-form_control="form_control" let-section="section"
  let-verificationObj="verificationObj" let-form_group="form_group" let-is_section="is_section"
  let-verification_status_list="verification_status_list">
  <ng-container *ngIf="verification_status_list && verification_status_list.length && verificationRequired">
    <tm-verification-status [verificationObj]="verificationObj" [form_control]="form_control" [field]="field"
      [section]="section" [form_group]="form_group" [is_section]="is_section"
      [verification_status_list]="verification_status_list" [callbackFn]="callbackFn" [alertId]="alertId">
    </tm-verification-status>
  </ng-container>
</ng-template>

<ng-template #plotSection let-section="section" let-dynamic_form_group="dynamic_form_group" let-masters="masters">

  <div class="row">
    <ng-container *ngFor="let item of (section.sectionFields||[]);">

      <span
        class="d-none">{{(section.multiple?section.multiple_form.value:dynamic_form_group.get(section.fieldID).value) |
        DynamicFormFieldProcessingPipe :
        dynamic_form_group.get(section.fieldID) : dynamic_form_group : section :
        item :
        (section.multiple?section.multiple_form.get(item.fieldID):
        dynamic_form_group.get(section.fieldID).get(item.fieldID)) :all_form?.value :
        all_form : masters}}
      </span>
      <ng-container *ngIf="true">
        <ng-container *ngIf="item.lineBreak">
          <div class="col-md-12"></div>
        </ng-container>

        <span *ngIf="item.parent_key" extendedFieldsDirective [masters]="masters" [field]="item"
          [form_group]="section.multiple ? section.multiple_form: dynamic_form_group.get(section.fieldID)"
          [form_control]="item.fieldID" [extendedFields]="sec_data[item.parent_key]" [section]="section"></span>


        <div [class]="'col-md-' + (item.width || 4)+' '+ item.controlClass"
          *ngIf="!(item && item.UIValidationObjStruct && item.UIValidationObjStruct.hide && item.UIValidationObjStruct.hide.value)">


          <div class="w-100 h-100 px-2 mb-2"
            [ngClass]="{'verificationEnabled' : !(section.multiple || section.skipVerification) && verificationRequired}">
            <ng-container
              *ngIf="!(section.multiple || section.skipVerification) && !item.skipVerification && verificationRequired">
              <ng-template
                *ngTemplateOutlet="verification_status; context: {field:item,section:section,form_group:dynamic_form_group.get(section.fieldID),form_control:dynamic_form_group.get(section.fieldID).get(item.fieldID),verificationObj:verificationObj,verification_status_list:verification_status_list}">
              </ng-template>
            </ng-container>

            <ng-template
              *ngTemplateOutlet="edit_mode; context: {item:item,hide_label:0,width:item.width || 6,section : section,form_group:section.multiple?section.multiple_form: dynamic_form_group.get(section.fieldID)}">
            </ng-template>
          </div>
        </div>
      </ng-container>
    </ng-container>
  </div>

  <div class=" row">
    <ng-container *ngIf="section && section.sections">
      <tm-dynamic-form-v3 [parent_form]="dynamic_form_group" [verificationRequired]="verificationRequired"
        [dynamic_form_group]="section.multiple?section.multiple_form : dynamic_form_group.get(section.fieldID)"
        [verificationObj]="verificationObj" [display_type]="section.sub_section_display_type"
        [sections]="section.sections" [masters]="masters" [verification_status_list]="verification_status_list"
        [callbackFn]="callbackFn" [alertId]="alertId" [type]="type" [disable_button]="disable_button" class="w-100"
        [sec_data]="sec_data" [extended_fields_titles]="extended_fields_titles" [all_form]="all_form">
      </tm-dynamic-form-v3>
    </ng-container>
    <div class="col-md-12">

      <ng-container *ngIf="section && section.multiple">
        <!-- {{parent_form.value | json}} -->
        <span *ngIf="section.parent_key" extendedFieldsDirective [form_group]="dynamic_form_group"
          [form_control]="section.fieldID" [extendedFields]="sec_data[section.parent_key]" [section]="section"></span>
        <tm-data-table [parent_form]="dynamic_form_group" [form_group]="dynamic_form_group" [section]="section"
          [masters]="masters" [verificationObj]="verificationObj">
        </tm-data-table>

      </ng-container>
    </div>
  </div>
</ng-template>